import { useRef } from 'react';
import { Wrapper, Panel, Menu, NavLink, ButtonWrapper } from './styles';
import ThemeButton from '../ThemeButton';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import scrollProps from '../../sections/Navigation/scrollProps';

const NavPanel = ({ isOpen, closePanel }) => {
  const innerRef = useRef();
  useOnClickOutside(innerRef, closePanel, isOpen);

  return (
    <Wrapper isOpen={isOpen}>
      <Panel isOpen={isOpen} ref={innerRef}>
        <Menu>
          <ButtonWrapper>
            <ThemeButton />
          </ButtonWrapper>
          <NavLink to="home" onClick={closePanel} {...scrollProps}>
            Home
          </NavLink>
          <NavLink to="skills" onClick={closePanel} {...scrollProps}>
            Skills
          </NavLink>
          <NavLink to="projects" onClick={closePanel} {...scrollProps}>
            Projects
          </NavLink>
          <NavLink to="contact" onClick={closePanel} {...scrollProps}>
            Contact
          </NavLink>
        </Menu>
      </Panel>
    </Wrapper>
  );
};

export default NavPanel;
